// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9e6efae2","144":"1f683e92","431":"c20dab00","489":"c327ae5d","492":"83600c6e","608":"20b12453"}[chunkId] + ".chunk.js";
};